import { CircleCheck, CircleExclamation, CircleXmark } from "@gravity-ui/icons";

import { StatusCardProps } from "./StatusCard.types";

export const ICON = {
  success: CircleCheck,
  warning: CircleExclamation,
  error: CircleXmark,
};

export const COLOR: Record<StatusCardProps["type"], string> = {
  success: "positive",
  warning: "warning",
  error: "danger",
};
